import {
  CreateEmploymentInfo,
  EmploymentInfoDTO,
  EmploymentStatus,
} from "@/models/employment-info.model";
import apiClient from "./apiClient";
import { getUTCDate } from "@/utils/date-format";

export async function getEmploymentInfoByUserId(
  userId: number
): Promise<EmploymentInfoDTO> {
  try {
    const res = await apiClient.get(`/users/${userId}/employment-info`);
    const data: EmploymentInfoDTO = res.data as EmploymentInfoDTO;
    return data;
  } catch (error) {
    console.log(error);
    return {} as EmploymentInfoDTO;
  }
}

export async function updateEmploymentInfoByEmploymentInfoId(
  id: number,
  args: {
    employmentStatus?: EmploymentStatus;
    lastDayOfWork?: Date;
    hireDate?: Date;
    confirmedDate?: Date;
    passType?: string;
    employmentType?: string;
  }
): Promise<EmploymentInfoDTO> {
  try {
    const res = await apiClient.patch(`/employment-info/${id}`, {
      ...args,
      hireDate: args.hireDate ? getUTCDate(args.hireDate) : undefined,
      confirmedDate: args.confirmedDate
        ? getUTCDate(args.confirmedDate)
        : undefined,
      lastDayOfWork: args.lastDayOfWork ? getUTCDate(args.lastDayOfWork)
        : undefined,
    });
    const data: EmploymentInfoDTO = res.data as EmploymentInfoDTO;
    return data;
  } catch (error) {
    console.log(error);
    return {} as EmploymentInfoDTO;
  }
}
